// extracted by mini-css-extract-plugin
export default {"actionWrapper":"AnswerButton_actionWrapper__BMpdx","clue":"AnswerButton_clue__GpQqY","comment":"AnswerButton_comment__jenqo"};